import React, { 
    useEffect,
    useRef,
    useState,
} from 'react';
import useHandle from '@/hooks/handle'
import CommonTable from '@/components/commonTable'
import moment from 'moment';
import {
    _yunKuOrderList,
    _yunKuExportOrderList,
    _yunKuStatistic,
} from "@/statics/js/api"
import { getJurisdiction } from "@/statics/js/jurisdiction";
import {
    Form,
    Button,
    Input,
    Row,
    Col,
    DatePicker
} from "antd";
import './index.less'

const columns = [
    {
        title: "用户手机号码",
        dataIndex: "userPhone",
        width: 140,
    },
    {
        title: "套餐金额",
        dataIndex: "payAmount",
        render: (text)=>(text || 0).toFixed(2)
    },
    {
        title: "套餐剩余天数",
        dataIndex: "leftDay",
    },
    {
        title: "实时电池串号",
        dataIndex: "imei",
    },
    {
        title: "所属商家",
        dataIndex: "agentName",
    },
    {
        title: "所属门店",
        dataIndex: "storeName",
    },
    {
        title: "套餐支付时间",
        dataIndex: "payTime",
        width: 180,
    },
    {
        title: "电池使用时间",
        dataIndex: "addTime",
        width: 180,
    },
]

const Index = Form.create({})((props)=> {
    const {form} = props
    const {getFieldDecorator,getFieldsValue} = form
    const tableRef = useRef();
    const [statistic,setStatistic] = useState({})
    const [defaultDate, setDefaultDate] = useState('')
    const {
        loading:exportLoading,
        handleDownload,
    } = useHandle()
    
    useEffect(()=>{
        handleSearch()
    },[])
    const initDefaultDate = ()=>{
        const values = getFieldsValue()
        let [startTime,endTime] = values.date || []
        if(startTime && endTime){
            startTime = moment(startTime).format('YYYY.MM.DD')
            endTime = moment(endTime).format('YYYY.MM.DD')
            setDefaultDate(`${startTime}~${endTime}`)
        }else{
            setDefaultDate('')
        }
    }
    const getStatistic = async ()=>{
        const values = getFieldsValue()
        const [startTime,endTime] = values.date || []
        const params = {
            timeStart: startTime ? moment(startTime).format('YYYY-MM-DD') : undefined,
            timeEnd: endTime ? moment(endTime).format('YYYY-MM-DD') : undefined,
        }
        const res = await _yunKuStatistic(params)
        const data = res.data.data || {}
        setStatistic(data)
    }
    const handleSearch = async (e)=>{
        e && e.preventDefault();
        initDefaultDate()
        getStatistic()
        const values = getFieldsValue()
        const [startTime,endTime] = values.date || []
        const params = {
            ...values,
            date: undefined,
            timeStart: startTime ? moment(startTime).format('YYYY-MM-DD') : undefined,
            timeEnd: endTime ? moment(endTime).format('YYYY-MM-DD') : undefined,
        }
        tableRef.current.handleSearch(params)
    }
    const handleExport = async ()=>{
        const values = getFieldsValue()
        const [startTime,endTime] = values.date || []
        handleDownload({
            action: _yunKuExportOrderList,
            query: {
                ...values,
                date: undefined,
                timeStart: startTime ? moment(startTime).format('YYYY-MM-DD') : undefined,
                timeEnd: endTime ? moment(endTime).format('YYYY-MM-DD') : undefined,
            }
        })
    }
    return (<div className="page_wrap">
        {
            getJurisdiction(1123) &&
            <div className='page_box'>
                <Row style={{marginBottom: '18px'}}>
                    <Col lg={10} md={10} sm={10}>
                        <label>总电池数</label>
                        <span>{statistic.batteryTotalNum}</span>
                    </Col>
                    <Col lg={14} md={14} sm={14}>
                        <label>今日运营效率</label>
                        <span>{statistic.dayRate}</span>
                    </Col>
                </Row>
                <Row>
                    <Col lg={10} md={10} sm={10}>
                        <label>今日在租电池数</label>
                        <span>{statistic.batteryRentNum}</span>
                    </Col>
                    <Col lg={14} md={14} sm={14}>
                        <label>区间运营效率</label>
                        <span>{statistic.monthRate}</span>
                        {
                            defaultDate && <span className='default_date'>({defaultDate})</span>
                        }
                    </Col>
                </Row>
            </div>
        }
        {
            getJurisdiction(1121) && 
            <div>
                <Form onSubmit={handleSearch} layout="inline">
                    <Row gutter={16}>
                        <Col lg={6} md={12} sm={24}>
                            <Form.Item label="关键词">
                                {getFieldDecorator("keyWord")(
                                    <Input allowClear placeholder='手机号/电池串号' />
                                )}
                            </Form.Item>
                        </Col>
                        <Col lg={6} md={12} sm={24}>
                            <Form.Item label="电池使用时间">
                                {getFieldDecorator("date",{
                                    initialValue: [moment().startOf('month'),moment()],
                                })(
                                    <DatePicker.RangePicker format="YYYY-MM-DD" />
                                )}
                            </Form.Item>
                        </Col>
                        <Col lg={6} md={12} sm={24}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit">搜索</Button>
                                <Button onClick={handleExport} style={{ marginLeft: 10 }} loading={exportLoading} disabled={!getJurisdiction(1122)}>导出</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div>
                    电池使用记录
                    {
                        defaultDate && <span className='default_date'>({defaultDate})</span>
                    }
                </div>
                <CommonTable
                    ref={tableRef}
                    auto={false}
                    action={_yunKuOrderList}
                    options={{
                        columns: columns
                    }}
                />
            </div>
        }
    </div>)
})

export default Index